import React, { useImperativeHandle, useMemo } from 'react';
import Grid from '@mui/material/Grid';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import { CheckboxInput } from 'sharedComponents/inputGroup';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';

const VehicleOption: React.ForwardRefRenderFunction<unknown, StepperFromProps> = ({ onNext, onBack }, ref) => {
  const { t } = useTranslation();

  const { vehicleOptions } = useSelector((state: RootState) => state.tradeInStore);

  const hasCalledNextStep = React.useRef(false);

  const { control, trigger } = useFormContext();

  const vehicleOptionsArray = useMemo(() => {
    return [
      {
        id: 1,
        label: t('stepperFormTradeIn.que1'),
        labelTxt: 'Select any options your vehicle has',
        options: vehicleOptions.map((option: { name: string; _id: string }, index) => ({
          value: `Option_${index + 1}`,
          label: option.name,
        })),
      },
    ];
  }, [vehicleOptions]);

  const nextStep = () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    onNext?.();
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <div className='tradein-v3__body'>
      <h4 className='tradein-v3__body__title text-primary'>{t('stepperFormTradeIn.vehicleOptions')}</h4>
      {vehicleOptionsArray?.map((question) => (
        <div key={question.id} className='mb-3'>
          <p>{t(question.label)}</p>
          <Grid container>
            {question?.options?.map((option) => (
              <Grid item xs={12} sm={4} key={option.value}>
                <CheckboxInput
                  name={`${question.id}_${option.value}`}
                  control={control}
                  label={t(option.label)}
                  triggerValidationForField={trigger}
                  // triggerValidationForField={() => {
                  //   const values = getValues();
                  //   const hasSelection = question.options.some((opt) => values[`${question.id}_${opt.value}`]);
                  //   if (hasSelection) {
                  //     clearErrors(question?.id?.toString());
                  //   } else {
                  //     setError(question?.id?.toString(), {
                  //       type: 'manual',
                  //       message: t('commonError.radioError'),
                  //     });
                  //   }
                  // }} // Temporary commented out
                />
              </Grid>
            ))}
          </Grid>
          {/* {errors[question.id] && <span className='validation-error'>{errors[question.id]?.message.toString()}</span>} // Temporary commented out */}
        </div>
      ))}
    </div>
  );
};

const VehicleOptionStep = React.forwardRef(VehicleOption);

export default VehicleOptionStep;
